import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { RefreshCw } from "lucide-react";

const BUNDLE = /static\/js\/main\.[a-z0-9]+\.js/;

/** Quando sai uma versão nova da plataforma, quem está com a página aberta é avisado e atualizado:
 *  - sempre aparece uma faixa "Atualizar agora";
 *  - na assinatura do contrato e no 1º acesso (telas curtas) atualiza sozinho, se a pessoa não estiver digitando. */
export const VersionWatcher = () => {
  const { user } = useAuth();
  const [novo, setNovo] = useState(false);
  const atual = useRef(null);

  useEffect(() => {
    const src = Array.from(document.scripts).map((s) => s.src).find((s) => BUNDLE.test(s)) || "";
    atual.current = (src.match(BUNDLE) || [null])[0];
    const checa = async () => {
      if (!atual.current) return;
      try {
        const r = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
        const v = ((await r.text()).match(BUNDLE) || [null])[0];
        if (v && v !== atual.current) setNovo(true);
      } catch (e) { /* sem internet: tenta depois */ }
    };
    const t = setInterval(() => { if (!document.hidden) checa(); }, 90000);
    const vis = () => { if (!document.hidden) checa(); };
    document.addEventListener("visibilitychange", vis);
    const first = setTimeout(checa, 15000);
    return () => { clearInterval(t); clearTimeout(first); document.removeEventListener("visibilitychange", vis); };
  }, []);

  useEffect(() => {
    if (!novo) return undefined;
    const curta = user?.contract_pending || window.location.pathname.startsWith("/primeiro-acesso");
    if (!curta) return undefined;
    const t = setTimeout(() => {
      const el = document.activeElement;
      if (el && /^(INPUT|TEXTAREA)$/.test(el.tagName)) return;     // está digitando: não perde o que escreveu
      window.location.reload();
    }, 6000);
    return () => clearTimeout(t);
  }, [novo, user]);

  if (!novo) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[200] flex items-center justify-center gap-3 px-4 py-2.5 text-sm text-white shadow-lg" style={{ background: "#1E9E2A" }} data-testid="version-banner">
      <RefreshCw className="h-4 w-4" />
      <span>Há uma versão nova da plataforma.</span>
      <button onClick={() => window.location.reload()} className="rounded-md bg-white text-[#1E9E2A] font-bold px-3 py-1 hover:bg-emerald-50">Atualizar agora</button>
    </div>
  );
};
